
export default {
  name: 'edit-note',

  props: {
    note: {
      type: Object,
      required: true,
    },
    notable_type: {
      type: String,
      required: true,
    },
    notable_uuid: {
      type: String,
      required: true,
    },
  },

  computed: {
    noteContents: {
      get() {
        return this.note.contents;
      },
      set(newVal) {
        this.$emit('update-note-contents', newVal);
      },
    },
  },
};
